import i18n from 'modules/core/lib/i18n'

import { parseConfigurationJson } from 'modules/inbox_tasks/tasks/employeeLifecycleStepAction/helpers'

export const getBasicTaskMetadata = (configurationJson?: string | null): string[] => {
  const config = parseConfigurationJson(configurationJson)
  const mandatory = config?.mandatory === true

  if (mandatory) {
    return [i18n.t('common.mandatory')]
  }

  return []
}
